import { Button } from '@ds';
import { getGroupedReservationsOnCase } from '@/utils/helpers';
import { DeviceReserveButtonTooltip } from './DeviceReserveButtonTooltip';
import { ReservationData, ResourceStatus } from '@/api/apis/resources';
import { Uuid } from '@/api/types';

type DeviceReserveButtonProps = {
  disabled?: boolean;
  caseId: Uuid;
  isLogistics: boolean;
  reservations: ReservationData[];
  onReserveClick: () => void;
  isSelected?: boolean;
};

export const DeviceReserveButton = ({
  disabled,
  caseId,
  isLogistics,
  reservations,
  isSelected,
  onReserveClick,
}: DeviceReserveButtonProps) => {
  const assignBtnClasses = isSelected ? 'text-danger-30 border-danger-30' : '';
  const isReservedOnCase = reservations.some(
    (r) => r.caseId === caseId && ![ResourceStatus.Done, ResourceStatus.Canceled].includes(r.status),
  );
  const [, currentReservations] = getGroupedReservationsOnCase(reservations);
  const isDisabled = disabled || isReservedOnCase || !!currentReservations.length;
  const isOutlined = isSelected || isDisabled;

  return (
    <DeviceReserveButtonTooltip
      isReservedOnCase={isReservedOnCase}
      isLogistics={isLogistics}
      reservations={reservations}
    >
      <div>
        <Button
          isDisabled={isDisabled}
          variant={isOutlined ? 'outline' : 'solid'}
          className={`text-s-sb py-2 w-24 h-auto ${assignBtnClasses}`}
          onPress={onReserveClick}
        >
          {isSelected ? 'Detach' : 'Reserve'}
        </Button>
      </div>
    </DeviceReserveButtonTooltip>
  );
};
